"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Layout = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = require("styled-components");
const react_router_dom_1 = require("react-router-dom");
const Header_1 = __importDefault(require("./Header"));
const origyn_art_ui_1 = require("@origyn/origyn-art-ui");
const origyn_art_ui_2 = require("@origyn/origyn-art-ui");
const Footer_1 = __importDefault(require("./Footer"));
const Layout = () => {
    const [darktheme, setDarktheme] = (0, react_1.useState)(false);
    const location = (0, react_router_dom_1.useLocation)();
    (0, react_1.useEffect)(() => {
        localStorage.setItem('theme', darktheme ? 'dark' : 'light');
    }, [darktheme]);
    (0, react_1.useLayoutEffect)(() => {
        const theme = localStorage.getItem('theme');
        if (theme) {
            setDarktheme(theme === 'dark' ? true : false);
        }
    }, []);
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(styled_components_1.ThemeProvider, { theme: darktheme ? origyn_art_ui_2.theme : origyn_art_ui_2.themeLight },
            react_1.default.createElement(origyn_art_ui_1.GlobalStyle, null),
            react_1.default.createElement(Header_1.default, { changeTheme: () => setDarktheme(!darktheme), isDarkTheme: !darktheme }),
            react_1.default.createElement(react_router_dom_1.Outlet, { context: darktheme }),
            react_1.default.createElement(Footer_1.default, null))));
};
exports.Layout = Layout;
